exports = function(val) {
    return typeof val === 'symbol';
};

module.exports = exports;
